import { c as _c } from "react/compiler-runtime";
import { ChatRestriction, SubmissionRestriction } from "@/hooks/useDropPriviledges";
function throwUnhandledRestriction(type: "chat" | "submission", restriction: string): never {
  throw new Error(`Unhandled ${type} restriction: ${restriction}`);
}
interface DropPlaceholderProps {
  readonly type: "chat" | "submission" | "both";
  readonly chatRestriction?: ChatRestriction | undefined;
  readonly submissionRestriction?: SubmissionRestriction | undefined;
}
export default function DropPlaceholder(t0) {
  const $ = _c(13);
  const {
    type,
    chatRestriction,
    submissionRestriction
  } = t0;
  let t1;
  if ($[0] !== chatRestriction || $[1] !== submissionRestriction || $[2] !== type) {
    t1 = () => {
      if (type === "chat" && chatRestriction) {
        switch (chatRestriction) {
          case ChatRestriction.NOT_LOGGED_IN:
            {
              return "Please log in to participate in chat";
            }
          case ChatRestriction.PROXY_USER:
            {
              return "Proxy users cannot participate in chat";
            }
          case ChatRestriction.SLOW_MODE:
            {
              return "Slow mode is active. Please wait before posting again";
            }
          case ChatRestriction.NO_PERMISSION:
            {
              return "You don't have permission to chat in this wave";
            }
          case ChatRestriction.DISABLED:
            {
              return "Chat is currently disabled for this wave";
            }
          default:
            {
              return throwUnhandledRestriction("chat", String(chatRestriction));
            }
        }
      }
      if (type === "submission" && submissionRestriction) {
        switch (submissionRestriction) {
          case SubmissionRestriction.NOT_LOGGED_IN:
            {
              return "Please log in to make submissions";
            }
          case SubmissionRestriction.PROXY_USER:
            {
              return "Proxy users cannot make submissions";
            }
          case SubmissionRestriction.NO_PERMISSION:
            {
              return "You don't have permission to submit in this wave";
            }
          case SubmissionRestriction.NOT_STARTED:
            {
              return "Submissions haven't started yet";
            }
          case SubmissionRestriction.ENDED:
            {
              return "Submission period has ended";
            }
          case SubmissionRestriction.MAX_DROPS_REACHED:
            {
              return "You have reached the maximum number of drops allowed";
            }
          default:
            {
              return throwUnhandledRestriction("submission", String(submissionRestriction));
            }
        }
      }
      if (type === "both") {
        if (chatRestriction === ChatRestriction.NOT_LOGGED_IN && submissionRestriction === SubmissionRestriction.NOT_LOGGED_IN) {
          return "Connect your wallet to participate in this wave";
        }
        return "You cannot participate in this wave at the moment";
      }
      return "Action not available";
    };
    $[0] = chatRestriction;
    $[1] = submissionRestriction;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getMessage = t1;
  let t2;
  if ($[4] !== chatRestriction || $[5] !== submissionRestriction || $[6] !== type) {
    t2 = () => {
      if (type === "chat" && chatRestriction === ChatRestriction.NOT_LOGGED_IN) {
        return "tw-text-primary-400";
      }
      if (type === "submission") {
        switch (submissionRestriction) {
          case SubmissionRestriction.NOT_LOGGED_IN:
            {
              return "tw-text-primary-400";
            }
          case SubmissionRestriction.NOT_STARTED:
            {
              return "tw-text-[#FEDF89]";
            }
          case SubmissionRestriction.ENDED:
            {
              return "tw-text-red";
            }
          case SubmissionRestriction.MAX_DROPS_REACHED:
            {
              return "tw-text-red";
            }
          default:
            {
              return "tw-text-iron-400";
            }
        }
      }
      return "tw-text-iron-400";
    };
    $[4] = chatRestriction;
    $[5] = submissionRestriction;
    $[6] = type;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getColor = t2;
  const t3 = `tw-mb-0 tw-text-sm tw-font-medium ${getColor()}`;
  let t4;
  if ($[8] !== getMessage) {
    t4 = getMessage();
    $[8] = getMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="tw-flex tw-min-h-[48px] tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-iron-800/50 tw-bg-iron-900/50 tw-px-4 tw-py-3 tw-backdrop-blur"><div className="tw-flex tw-flex-col"><p className={t3}>{t4}</p></div></div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}